// NOTE: these .json files are generated from the corresponding resources/lang/**/*.php
// files by `bin/export-lang-json.php` (run automatically via the "predev"/"prebuild"
// npm scripts, replacing the old laravel-localization-loader webpack loader).
// Re-run `php bin/export-lang-json.php` after editing any source PHP lang file below.
import enAccount from '../lang/en/sections/auth/account.json';
import enAuth from '../lang/en/auth.json';
import enCalendar from '../lang/en/sections/auth/calendar.json';
import enCategories from '../lang/en/categories.json';
import enCompanies from '../lang/en/sections/auth/companies.json';
import enContacts from '../lang/en/sections/auth/contacts.json';
import enDocuments from '../lang/en/sections/auth/documents.json';
import enFinancial from '../lang/en/sections/auth/financial.json';
import enGlobal from '../lang/en/global.json';
import enHr from '../lang/en/hr.json';
import enImages from '../lang/en/sections/auth/images.json';
import enLicense from '../lang/en/license.json';
import enMainHeader from '../lang/en/sections/auth/main-header.json';
import enMenu from '../lang/en/sections/menu.json';
import enNobusinessAccount from '../lang/en/vue/nobusiness/account.json';
import enNotes from '../lang/en/notes.json';
import enNotifications from '../lang/en/notifications.json';
import enPermissions from '../lang/en/permissions.json';
import enPlanning from '../lang/en/sections/auth/planning.json';
import enProjects from '../lang/en/sections/auth/projects.json';
import enServertable from '../lang/en/servertable.json';
import enSettings from '../lang/en/sections/auth/settings.json';
import enSupport from '../lang/en/sections/auth/support.json';
import enTasks from '../lang/en/sections/auth/tasks.json';
import enTimeregistration from '../lang/en/sections/auth/timeregistration.json';
import enUsers from '../lang/en/users.json';
import enValidation from '../lang/en/validation.json';

import nlAccount from '../lang/nl/sections/auth/account.json';
import nlAuth from '../lang/nl/auth.json';
import nlCalendar from '../lang/nl/sections/auth/calendar.json';
import nlCategories from '../lang/nl/categories.json';
import nlCompanies from '../lang/nl/sections/auth/companies.json';
import nlContacts from '../lang/nl/sections/auth/contacts.json';
import nlDocuments from '../lang/nl/sections/auth/documents.json';
import nlFinancial from '../lang/nl/sections/auth/financial.json';
import nlGlobal from '../lang/nl/global.json';
import nlHr from '../lang/nl/hr.json';
import nlImages from '../lang/nl/sections/auth/images.json';
import nlLicense from '../lang/nl/license.json';
import nlMainHeader from '../lang/nl/sections/auth/main-header.json';
import nlMenu from '../lang/nl/sections/menu.json';
import nlNobusinessAccount from '../lang/nl/vue/nobusiness/account.json';
import nlNotes from '../lang/nl/notes.json';
import nlNotifications from '../lang/nl/notifications.json';
import nlPermissions from '../lang/nl/permissions.json';
import nlPlanning from '../lang/nl/sections/auth/planning.json';
import nlProjects from '../lang/nl/sections/auth/projects.json';
import nlServertable from '../lang/nl/servertable.json';
import nlSettings from '../lang/nl/sections/auth/settings.json';
import nlSupport from '../lang/nl/sections/auth/support.json';
import nlTasks from '../lang/nl/sections/auth/tasks.json';
import nlTimeregistration from '../lang/nl/sections/auth/timeregistration.json';
import nlUsers from '../lang/nl/users.json';
import nlValidation from '../lang/nl/validation.json';

export default {
    // The key format should be: 'locale.filename'.
    'en.account': enAccount,
    'en.auth': enAuth,
    'en.calendar': enCalendar,
    'en.categories': enCategories,
    'en.companies': enCompanies,
    'en.contacts': enContacts,
    'en.documents': enDocuments,
    'en.financial': enFinancial,
    'en.global': enGlobal,
    'en.hr': enHr,
    'en.images': enImages,
    'en.license': enLicense,
    'en.main-header': enMainHeader,
    'en.menu': enMenu,
    'en.nobusiness-account': enNobusinessAccount,
    'en.notes': enNotes,
    'en.notifications': enNotifications,
    'en.permissions': enPermissions,
    'en.planning': enPlanning,
    'en.projects': enProjects,
    'en.servertable': enServertable,
    'en.settings': enSettings,
    'en.support': enSupport,
    'en.tasks': enTasks,
    'en.timeregistration': enTimeregistration,
    'en.users': enUsers,
    'en.validation': enValidation,

    'nl.account': nlAccount,
    'nl.auth': nlAuth,
    'nl.calendar': nlCalendar,
    'nl.categories': nlCategories,
    'nl.companies': nlCompanies,
    'nl.contacts': nlContacts,
    'nl.documents': nlDocuments,
    'nl.financial': nlFinancial,
    'nl.global': nlGlobal,
    'nl.hr': nlHr,
    'nl.images': nlImages,
    'nl.license': nlLicense,
    'nl.main-header': nlMainHeader,
    'nl.menu': nlMenu,
    'nl.nobusiness-account': nlNobusinessAccount,
    'nl.notes': nlNotes,
    'nl.notifications': nlNotifications,
    'nl.permissions': nlPermissions,
    'nl.planning': nlPlanning,
    'nl.projects': nlProjects,
    'nl.servertable': nlServertable,
    'nl.settings': nlSettings,
    'nl.support': nlSupport,
    'nl.tasks': nlTasks,
    'nl.timeregistration': nlTimeregistration,
    'nl.users': nlUsers,
    'nl.validation': nlValidation,
}
